<template>
  <div>
    <!-- <el-input type="text" v-model="loginForm.username" placeholder="用户名"></el-input> -->
    <el-row>
      <el-col :span="14" :offset="5">
        <input v-model="loginForm.password" @keyup.enter="login()" placeholder="输入口令" class="pw_input" />
      </el-col>
    </el-row>
  </div>

</template>

<script>
  import {
    mapMutations
  } from 'vuex'
  export default {
    name: 'Login',
    data() {
      return {
        loginForm: {
          username: 'guest',
          password: ''
        }
      }
    },
    created() {},
    methods: Object.assign({}, mapMutations(['changeLogin']), {
      // ...mapMutations(['changeLogin']),
      login: function() {
        let _this = this
        if (_this.loginForm.username === '' || _this.loginForm.password === '') {
          this.$message.error('账号密码不能为空')
        } else {
          this.$axios({
              method: 'POST',
              url: '/api/login/',
              data: _this.loginForm
            })
            .then(response => {
              if (0 == response.data.code) {
                let userToken = 'guest ' + response.data.message
                _this.userToken = _this.$md5(userToken)
                console.log(_this.userToken)
                _this.changeLogin({
                  Authorization: _this.userToken
                })
                _this.$router.push('/in_process')
                this.$message({
                  message: '登录成功',
                  type: 'success'
                })
              } else {
                this.$message.error('请检查密码')
              }
            })
        }

      }
    }),
  }
</script>

<style>
  .pw_input {
    position: relative;
    top: 6.25rem;
    border: 1px solid;
    width: 100%;
    height: 2.25rem;
    border-radius: 2.25rem;
    outline: none;
    padding: 0.325rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue